module.exports = __webpack_public_path__ + "img/various-legumes.885da29b.jpg";